/**
 * * Keeps a pointer gesture until the finger lifts.
 * * A phone cancels the pointer after a few pixels unless the move stays captured
 * * and the browser is told not to scroll.
 */

export function trackPointer(
  event: { pointerId: number; currentTarget: EventTarget | null; preventDefault: () => void },
  onMove: (event: PointerEvent) => void,
  onEnd: (event: PointerEvent) => void,
): void {
  event.preventDefault()
  const target = event.currentTarget
  if (target instanceof Element) {
    try {
      target.setPointerCapture(event.pointerId)
    } catch {
      // * Capture is refused when the pointer is already gone.
    }
  }
  const pointerId = event.pointerId
  let ended = false
  const move = (ev: PointerEvent) => {
    if (ev.pointerId !== pointerId) {
      return
    }
    if (ev.cancelable) {
      ev.preventDefault()
    }
    onMove(ev)
  }
  const end = (ev: PointerEvent) => {
    if (ended || ev.pointerId !== pointerId) {
      return
    }
    ended = true
    window.removeEventListener('pointermove', move)
    window.removeEventListener('pointerup', end)
    window.removeEventListener('pointercancel', end)
    onEnd(ev)
  }
  window.addEventListener('pointermove', move, { passive: false })
  window.addEventListener('pointerup', end)
  window.addEventListener('pointercancel', end)
}
